import Icon, { CloseOutlined } from '@ant-design/icons';
import { Button, Flex, Modal } from 'antd';
import React from 'react';
import CustomCheckmarkIcon from '~/assets/svg/icon-checkmark.svg?react';

function CloseConversationModal({ open, onCancel, onConfirm, loading }) {
  return (
    <Modal open={open} closeIcon={null} footer={null} maskClosable={false} centered>
      <Flex vertical gap={16}>
        <div className='flex justify-end'>
          <Button className='btn-icon' size='large' onClick={onCancel} type='text' icon={<CloseOutlined />} />
        </div>
        <Flex vertical gap={24}>
          <p className='body2'>Êtes-vous sûr que la réclamation/la discussion est bien terminée ?</p>
          <p className='body1 text-error'>Une fois clôturée, votre destinataire ne peut plus vous envoyer de message.</p>
        </Flex>
        <Flex gap={8} align='center' justify='flex-end'>
          <Button onClick={onCancel} type='link' className=''>
            Annuler
          </Button>
          <Button type='primary' danger onClick={onConfirm} loading={loading} disabled={loading} className='btn-success'>
            Clôturer la conversation
            <Icon component={CustomCheckmarkIcon} className='text-[24px]' />
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
}

export default CloseConversationModal;
